import * as React from 'react';
import { connect } from 'react-redux';
import { fetchPublicacion, editPublicacion } from '../../../../actions/publicacionesActions';
import ImageUploader from './ImageUploader';

class Imagenes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            imagenes: []
        }
    }

    render() {
        return (
           
            <div>
                 <ImageUploader /> 
            </div>
        )
    }
}

const mapStateToProps = state => ({
    publicacion: state.publicaciones.publicacion,
});

export default connect(mapStateToProps, { fetchPublicacion, editPublicacion })(Imagenes);